var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-text-field-simplemask',{attrs:{"label":_vm.label,"rules":_vm.rules,"properties":{
    prefix: '',
    suffix: '',
    readonly: false,
    disabled: false,
    outlined: true,
    dense: _vm.$root.dense,
    clearable: false,
    placeholder: ''
  },"options":{
    inputMask: '(##)(###) ###-####',
    outputMask: '############',
    empty: null,
    applyAfter: false,
    alphanumeric: false,
    lowerCase: false
  }},on:{"input":function($event){return _vm.$emit('input', _vm.model)}},model:{value:(_vm.model),callback:function ($$v) {_vm.model=$$v},expression:"model"}})}
var staticRenderFns = []

export { render, staticRenderFns }